import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import noop from '../../../utils/noop';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './UserSymbol.scss';
function useUserSymbolTranslation(userSymbol) {
    const { t } = useTranslation();
    switch(userSymbol){
        case 'admin':
            return t('userSymbolsPopup.symbols.admin.title');
        case 'banned':
            return undefined;
        case 'beta':
            return t('userSymbolsPopup.symbols.beta.title');
        case 'buyer':
            return undefined;
        case 'group':
            return t('userSymbol.a11y.group.title');
        case 'hell':
            return t('userSymbolsPopup.symbols.hell.title');
        case 'hell-beta':
            return t('userSymbolsPopup.symbols.hell-beta.title');
        case 'premium':
            return t('userSymbolsPopup.symbols.premium.title');
        case 'regular':
            return undefined;
        case 'senior':
            return t('userSymbolsPopup.symbols.senior.title');
        case 'super':
            return t('userSymbol.a11y.superGroup.title');
        case 'volunteer':
            return t('userSymbolsPopup.symbols.volunteer.title');
        case 'core_access':
            return t('userSymbolsPopup.v2.symbols.core_access.title');
        case 'core_plus':
            return t('userSymbolsPopup.v2.symbols.core_plus.title');
        case 'core_pro':
            return t('userSymbolsPopup.v2.symbols.core_pro.title');
        case 'core_pro_plus':
            return t('userSymbolsPopup.v2.symbols.core_pro_plus.title');
        case 'core_max':
            return t('userSymbolsPopup.v2.symbols.core_max.title');
        default:
            return undefined;
    }
}
export const UserSymbol = ({ userSymbol, className, biData, openUserSymbolPopup = false, pushUserSymbolsPopup = noop, 'aria-hidden': ariaHidden })=>{
    const label = useUserSymbolTranslation(userSymbol);
    const spanProps = {
        className: classnames(s['symbol'], s[userSymbol], className),
        style: openUserSymbolPopup ? {
            cursor: 'pointer'
        } : {},
        title: label,
        'aria-label': label,
        'aria-hidden': ariaHidden
    };
    if (openUserSymbolPopup) {
        const biEventData = BiData(_object_spread_props(_object_spread({}, biData), {
            symbol: userSymbol,
            evid: 111
        }));
        const onClick = (ev)=>{
            ev.preventDefault();
            // Only open the popup if we're not in an iframe
            if (window.self === window.top) {
                pushUserSymbolsPopup();
            }
        };
        return /*#__PURE__*/ React.createElement(BiSpan, _object_spread_props(_object_spread({}, spanProps), {
            // Role = "img" here to allow aria-label to exist on
            // this element without lighthouse throwing a fit
            role: "img",
            biData: biEventData,
            onClick: onClick,
            stopPropagation: true
        }));
    }
    return /*#__PURE__*/ React.createElement("span", spanProps);
};
UserSymbol.displayName = 'UserSymbol';
export default UserSymbol;

//# sourceMappingURL=UserSymbol.js.map